export default "__VITE_ASSET__ctX4i3m___"